import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { IAfterSalesResponse } from 'store/afterSales/types'

export default class AfterSalesService {
  static async getAfterSales() {
    let headers = {}

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': (await BaseBridge.getUserInfo()).account,
      }
    }

    const response = await BaseService.doExecute<IAfterSalesResponse>({
      method: 'GET',
      endpoint: `${process.env.REACT_APP_API_PET}/posSales`,
      headers,
    })

    return response.data
  }
}
